import { RefObject, MouseEvent } from 'react'

import { isFunction } from '@surglogs/util.is-function'

import { useHandler } from './useHandler'

export const useOnRefTargetClick = (
  ref: RefObject<HTMLElement | null>,
  callback?: () => void,
  condition?: (e: MouseEvent) => boolean,
): ((e: MouseEvent) => void) =>
  useHandler((e: MouseEvent) => {
    if (
      ref.current &&
      e.target instanceof Node &&
      !ref.current.contains(e.target) &&
      (condition && isFunction(condition) ? condition(e) : true) &&
      isFunction(callback)
    ) {
      callback()
    }
  })
